const contestationFactory = {
  toAPI: (data, transactionId) =>
    data &&
    transactionId && {
      transactionId,
      reason: 1,
      details: data.name
    }
}

export default contestationFactory



// WEBPACK FOOTER //
// ./src/app/pages/Contestation/factory.js